/**
 * ExerciseCounter - Skipping counter component
 *
 * This is a thin wrapper around UnifiedExerciseCounter for backwards compatibility.
 * Uses MoveNet pose detection for skipping counting.
 */
import UnifiedExerciseCounter from './UnifiedExerciseCounter';

const ExerciseCounter = ({
  activityId,
  sessionId,
  railsEnv = 'development',
  requiredReps,
  initialReps = 0,
  onComplete,
  onProgressSave,
  exerciseType = 'skipping',
  onRepComplete,
  onSessionEnd,
  labels = {},
  showReportButton = false,
  streamingUploadUrl = null,
  showMaxFPSOption = false,
  // Admin-configured inference engine ('tfjs-webgl' | 'onnx-webgpu').
  // Passed through from componentProps in ActivityContent → ReactAppMounter.
  engine
}) => {
  // Map old labels format to new format
  const mappedLabels = {
    title: labels.jump_rope_counter || labels.exercise_counter,
    start_exercise: labels.start_exercise,
    start_with_streaming: labels.start_with_streaming,
    stop_exercise: labels.stop_exercise,
    resume_exercise: labels.resume_exercise,
    resume_with_streaming: labels.resume_with_streaming,
    finish_exercise: labels.finish_exercise,
    test_sound: labels.test_sound,
    report_inaccuracy: labels.report_inaccuracy,
    start_over: labels.start_over,
    reps_completed: labels.reps_completed,
    goal: labels.goal,
    loading_model: labels.loading_model,
    camera_tip: labels.camera_tip,
    goal_achieved: labels.goal_achieved,
    did_you_hear_beep: labels.did_you_hear_beep,
    yes: labels.yes,
    no: labels.no,
    check_silent_mode: labels.check_silent_mode,
    ok: labels.ok,
    start: labels.start,
    camera_sees_whole_body: labels.camera_sees_whole_body,
    beep_on_correct_rep: labels.beep_on_correct_jump
  };

  // Filter out undefined values
  const filteredLabels = Object.fromEntries(
    Object.entries(mappedLabels).filter(([_, v]) => v !== undefined)
  );

  return (
    <UnifiedExerciseCounter
      exerciseType={exerciseType}
      requiredReps={requiredReps}
      initialReps={initialReps}
      onComplete={onComplete}
      onRepComplete={onRepComplete}
      onProgressSave={onProgressSave}
      onSessionEnd={onSessionEnd}
      labels={filteredLabels}
      railsEnv={railsEnv}
      showPreStartChecklist={true}
      showReportButton={showReportButton}
      showRecordingControls={false}
      streamingUploadUrl={streamingUploadUrl}
      showMaxFPSOption={showMaxFPSOption}
      {...(engine ? { engine } : {})}
    />
  );
};

export default ExerciseCounter;
